import React, { useEffect, useState } from 'react';
import {
    Grid, Box, Typography, FormControlLabel, Switch, FormControl,
    InputLabel, Select, MenuItem, IconButton, TextField
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add } from '@mui/icons-material';

const operatorOptions = ["=", "LIKE", "<>"];
export const ManageOtherActions = ({ data = {}, table = [], handleSave, t }) => {
    const [selectCompany, setSelectCompany] = useState(data?.select_company ?? false);
    const [filters, setFilters] = useState(data?.filters ?? {});
    const [selectedField, setSelectedField] = useState("");
    const filterableColumns = table.filter(c => c.filterable && c.id !== "id");
    useEffect(() => {
        handleSave("filters", filters);
    }, [filters]);

    useEffect(() => {
        handleSave("select_company", selectCompany);
    }, [selectCompany]);

    const handleAddFilter = () => {
        if (!selectedField) return;
        const col = table.find(c => c.id === selectedField);
        if (!col) return;
        setFilters(prev => ({
            ...prev,
            [selectedField]: { value: "",operator: "=", type: col.type}
        }));
        setSelectedField("");
    };

    const handleFilterChange = (id, field, value) => {
        setFilters(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: value,
                error: field === "value" && value.trim() === "" ? true : false
            }
        }));
    };


    const handleDeleteFilter = (id) => {
        const updated = { ...filters };
        delete updated[id];
        setFilters(updated);
    };

    return (
        <Box sx={{ mt: 3 }}>
            <FormControlLabel
                control={<Switch checked={selectCompany} onChange={e => setSelectCompany(e.target.checked)} />}
                label={t("common.companySelect")}
            />

            {filterableColumns && filterableColumns.length > 0 && (
                <>
                    <Typography variant='subtitle1' sx={{ mt: 2, mb: 2 }}>{t('common.filter.filters')}</Typography>
                    <Grid container spacing={2} sx={{ mb: 2, display:'flex', justifyContent:'flex-end' }}>
                        <Grid size={{xs:10, sm:4}}>
                            <FormControl fullWidth size="small">
                                <InputLabel>{t('common.filter.selectField')}</InputLabel>
                                <Select
                                    label={t('common.filter.selectField')}
                                    value={selectedField}
                                    onChange={e => setSelectedField(e.target.value)}
                                >
                                    {filterableColumns.map(col => <MenuItem key={col.id} value={col.id}>{col.label} ({col.type})</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={{xs:2, sm:1}}>
                            <IconButton color="primary" onClick={handleAddFilter} disabled={!selectedField}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {Object.entries(filters).map(([key, cfg]) => (
                        <Grid
                            container
                            spacing={2}
                            key={key}
                            alignItems="center"
                            sx={{
                            backgroundColor: "#fafafa",
                            borderRadius: 2,
                            px: 2,
                            py: 1.5,
                            mb: 1.5
                            }}
                        >
                            {/* Campo */}
                            <Grid item xs={12} sm={2}>
                            <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 600 }}
                            >
                                {key}
                            </Typography>
                            </Grid>

                            {/* Valor */}
                            <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label={t('common.filter.value')}
                                value={cfg.value}
                                onChange={({ target: { value } }) =>
                                handleFilterChange(key, "value", value)
                                }
                            />
                            </Grid>

                            {/* Operador */}
                            <Grid item xs={12} sm={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel>{t('common.filter.operator')}</InputLabel>
                                <Select
                                label={t('common.filter.operator')}
                                value={cfg.operator}
                                onChange={({ target: { value } }) =>
                                    handleFilterChange(key, "operator", value)
                                }
                                >
                                {operatorOptions.map(op => (
                                    <MenuItem key={op} value={op}>
                                    {op}
                                    </MenuItem>
                                ))}
                                </Select>
                            </FormControl>
                            </Grid>

                            {/* Tipo */}
                            <Grid item xs={12} sm={2}>
                            <TextField
                                fullWidth
                                size="small"
                                disabled
                                label={t('commonFields.type')}
                                value={cfg.type}
                            />
                            </Grid>

                            {/* Eliminar */}
                            <Grid item xs={12} sm={2} sx={{ textAlign: "center" }}>
                            <IconButton
                                color="error"
                                onClick={() => handleDeleteFilter(key)}
                            >
                                <DeleteIcon />
                            </IconButton>
                            </Grid>
                        </Grid>
                    ))}

                </>
            )}
            
        </Box>
    );
};
